import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex flex-col gap-20 md:flex-row"
    >
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2021 - Present</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="SIG Developer & Devops"
            subTitle="GEOSM Family - (October 2023 - Present)"
            result="Yaounde"
            des="Design and development of GIS and maintenance of deployment servers with more than 5 Geoportails. Integration of scalable vector tile solutions on GIS processing millions of geographic data."
          />
          <ResumeCard
            title="IT System Manager"
            subTitle="Erna Agency Consulting - (Ferbuary 2023 - Present)"
            result="Yaounde"
            des="Responsible for project development, supervision of the development team using the agile method, organization of development procedures using the SCRUM agile method, management of servers and deployment environments"
          />
          <ResumeCard
            title="FullStack Developer & Tech Lead"
            subTitle="Tentee Global - (June 2022 - Febuary 2024)"
            result="Yaounde"
            des="Development and maintenance of web and mobile applications, writing unit tests, security testing and code review. CI/CD deployment and integration of DevOps tools into the ecosystem."
          />
        </div>
      </div>
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023</p>
          <h2 className="text-4xl font-bold">Trainer Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Mobile Developper and Instructor"
            subTitle="Freelance (May 2023 - July 2023)"
            result="Cameroun"
            des="Sharing of mobile development skills, mobile concepts, and notions of API use in mobile !"
          />
          <ResumeCard
            title="Web Developer and Instructor"
            subTitle="Tentee Global - (Febuary 2023 - April 2023)"
            result="Cameroun"
            des="Sharing web development skills, APIS concepts, their designs, execution of unit tests..."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
